module.exports = __webpack_public_path__ + "img/荣誉证书2.d0dab14e.png";